import { useEffect, useState } from "react";
import styles from "./FreeTrialWhatsappModal.module.css";
import { createOrder, pgiAutoLogin } from "../../Services/pgi";
import {fetchDbConstants} from "../../Services/marketingAutomation"
import moment from "moment";
import { url } from "../../Values/constants";
import { connect, useDispatch } from "react-redux";
import axiosHandler from "../../Services/axiosHandler";
import { pushToGA ,googleAnalytics} from '../../Services/users';
import AutomaticBillSetUpContent from "../AutomaticBillSetUpContent/AutomaticBillSetUpContent";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import AutomaticBillPayementContent from "../AutomaticBillPayementContent/AutomaticBillPayementContent";
import GSTModal from "../GSTModal/GSTModal";
import { useHistory } from "react-router-dom";
import { readproPackagePurchaseViaPGI } from "../../Services/pgi";

interface FreeTrialWhatsappModalProps {closePopup?:any; user?: any;organizationData?: any;}

const FreeTrialWhatsappModal: React.FC<FreeTrialWhatsappModalProps> = ({ closePopup, user,organizationData}) => {

        

    const [roiDates, setRoiDates] = useState([
        // "Top agents are achieving",
        // "50% higher conversion with",
        // " ",
        // "WhatsApp Business on ReadPro"
    ]);
    const [roiDatesGA, setRoiDatesGA] = useState([]);
    const [roiDay, setRoiDay] = useState<string>("");
    const [token,setToken] = useState<any>()
     const [gst, setGst] = useState<any>();
      const [originalPrice, setOriginalPrice] = useState();
      const [packageId, setPackageId] = useState();
      const [isRecurringPay, setIsRecurringPay] = useState<any>("N");
       const [whatsappRechangePlan, setWhatsappRechangePlan] = useState([
            {
              id:"",
              isTopup: false,
              discountedValue: "",
              originalValue: "",
              discountPercent: "",
              validity: "",
              balance: "",
              packageId:"",
            }
          ]);

     const [finalwhatsappRechangePlan, setFinalWhatsappRechangePlan] = useState([
            {
              id:"",
              isTopup: false,
              discountedValue: "",
              originalValue: "",
              discountPercent: "",
              validity: "",
              balance: "",
              packageId:"",
            }
          ]);
    const [activeFilters, setActiveFilters] = useState<string[]>(["Recharge"]);
    const [defaultPackage, setDefaultPackage] = useState<any>();
    const [offerPrice, setOfferPrice] = useState();
    const [balance, setBalance] = useState();
    const [val, setVal] = useState();
    const [discountVal, setdiscountVal] = useState();
    const [openTryAutoPayModal, setOpenTryAutoPayModal] = useState<boolean>(false);
    const [openGstModal, setOpenGstModal] = useState<boolean>(false);
    const [openSetUpAutoPayModal, setOpenSetUpAutoPayModal] = useState<boolean>(false);
    const [recr, setRecr] = useState<any>();
    const history = useHistory();
    const [freePack, setFreePack] = useState<any>();
    const dispatcher = useDispatch();
    
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data: any = await fetchDbConstants(["roiDates"]);
        if (data && data[0]?.data?.[0]) {
          const currentDay = moment().format("dddd");

          setRoiDay(currentDay);

          const roiDatesValue = data[0].data[0][currentDay];
          if (roiDatesValue !== undefined) {
            setRoiDates(roiDatesValue);
            setRoiDatesGA(roiDatesValue)
          }
        }
      } catch (error: any) {
        // console.log("Error fetching ROI dates:", error.message);
      }
    };

    fetchData();
  }, []);

    const filterData = (data: any[], activeFilters: string[]) => {
        if (activeFilters.includes("Topup") && activeFilters.includes("Recharge")) {
          // Return all data if both filters are active
          // console.log(data);
          return data;
        }
      
        if (activeFilters.includes("Topup")) {
          // Filter data where isTopup is true
          const filteredData = data.filter(item => item.isTopup === true);
          // console.log(filteredData);
          return filteredData;
        }
      
        // Otherwise, filter data where isTopup is false
        const filteredData = data.filter(item => item.isTopup === false);
        // console.log(filteredData);
        return filteredData;
      };


  useEffect(() => {
    readProductList()
  }, [user])

    const readProductList = async () => {
        // const apiUrl = url+"/pgi/readProductList";
    
        const apiUrl =url+"/pgi/readProductList"
    
        const payload = {
              soid: user.user_super_oid,
        };
      
        try {
          // console.log(" payload:", payload);
      
          const response = await axiosHandler.post(apiUrl, payload);
    
          // console.log("response",response.data.responsePayloadData.pgiRefId)
          const data = response.data;
        //   console.log("data.data",data.data)
          setWhatsappRechangePlan(data.data)
          setFreePack(data.FREE_PACK)
          const mainData = data.data.map((plan:any, index:any) => {
            const isPopular = index === 0; // Example logic for isPopular
            const isBestValue = index === 1; // Example logic for isBestValue
            const discountedValue = plan.discountedValue
              // plan.discountPercent === "100"
              //   ? plan.discountedValue
              //   : (plan.originalValue * (100 - plan.discountPercent)) / 100;
          
            return {
              id: (index + 1).toString(),
              isPopular,
              isBestValue,
              isTopup: plan.isTopup,
              discountedValue: discountedValue.toString(),
              originalValue: plan.originalValue,
              discountPercent: plan.discountPercent,
              validity: plan.validity,
              balance: plan.balance,
              packageId: plan.packageId,
            };
          });
          setFinalWhatsappRechangePlan(filterData(mainData,activeFilters))
    
        } catch (error:any) {
          // Handle errors
        //   console.error("Error fetching responses:", error.response || error);
          throw error;
        }
      };

      useEffect(()=>{
      // console.log("filteredPlans",filteredPlans)
      const filteredPlan = finalwhatsappRechangePlan.filter(
        (plan: any) => plan.packageId !== freePack
        );
          if (filteredPlan.length === 0) {
              setDefaultPackage(null); // No valid packages left
              return;
          }
          
          const minPackage = filteredPlan.reduce((prev: any, current: any) => {
            return parseFloat(prev.discountedValue || "0") <= parseFloat(current.discountedValue || "0")
              ? prev
              : current;
          });
          setDefaultPackage(minPackage)
               },[finalwhatsappRechangePlan,freePack])

          const [isGACalled, setIsGACalled] = useState<any>(false);
   
             useEffect(() => {
                    if (!isGACalled && Array.isArray(roiDatesGA) && roiDatesGA.length > 1) {
                      // console.log("roiDatesGA", roiDatesGA);
                  
                      if (user?.uid && user?.profile) {
                        setIsGACalled(true);
                        googleAnalytics(`freeTrialMarketingPopup(${roiDatesGA[0]}${roiDatesGA[1]})`, user);
                      }
                    }
                  }, [user, roiDatesGA, isGACalled]);
  

     
    
    
    return (
        <div className={styles.ftw}>
            <div className={styles.ftwText1}>Now send</div>
            <div className={styles.ftwText2}>Bulk <span className={styles.ftwText2Green}>WhatsApp</span> messages <div className={styles.ftwText2Small}>straight from ReadPro!</div></div>
            <div className={styles.ftwText3}><span className={styles.textSemiBold}>End-to-end encrypted</span> lead data</div>
            <div className={styles.ftwBenefits}>
                <div className={`${styles.ftwBenefitTab} ${styles.ftwBenefitTab1}`}>Verified <br /> account with <br /> <span className={styles.ftwBenefitTabBold}>Blue Tick.</span></div>
                <div className={`${styles.ftwBenefitTab} ${styles.ftwBenefitTab2}`}>Schedule <span className={styles.ftwBenefitTabBold}>Automatic</span> Promotions</div>
                <div className={`${styles.ftwBenefitTab} ${styles.ftwBenefitTab3}`}>Real Estate focused <span className={styles.ftwBenefitTabBold}>Message templates</span></div>
            </div>
            <div className={styles.ftwBonus}>
                <div className={styles.ftwBonusAmt}><span className={styles.rupees}>&#8377;</span>500</div> 
                <div className={styles.ftwBonusText}>WELCOME BONUS</div></div>
            <div className={styles.ftwCta}>
                <div className={styles.ftwCtaPrim} onClick={() => {
                                    if(Array.isArray(roiDatesGA) && roiDatesGA.length > 1){
                                      pushToGA(
                                        "event_tracking",
                                        "read pro",
                                        "read pro",
                                        `whatsapp freeTrialMarketingPopup(${roiDatesGA[0]}${roiDatesGA[1]}) | cta :Start Trial Now click`,
                                        user,
                                        // eventLabel ? eventLabel : ""
                                      )
                                    }

                                    readproPackagePurchaseViaPGI(user.user_super_oid, freePack, dispatcher, false);
                                }}>Start Your Trial for just <span className={styles.rupees}>&#8377;</span> 1</div>
                <div className={styles.ftwCtaSec} 
                onClick={() => {
                                                    if (Array.isArray(roiDatesGA) && roiDatesGA.length > 1) {
                                                      pushToGA(
                                                        "event_tracking",
                                                        "read pro",
                                                        "read pro",
                                                        `whatsapp freeTrialMarketingPage(${roiDatesGA[0]}${roiDatesGA[1]}) | cta :explore packages`,
                                                        user,
                                                        // eventLabel ? eventLabel : ""
                                                      )
                                                    }
                                                    closePopup(false)
                                                    history.push("/marketing")
                                                  }}>Know more &gt;</div>
            </div>
            <div className={styles.ftwDisc}>Only <span className={styles.rupees}>&#8377;</span>{defaultPackage?.discountedValue !== "0" ? defaultPackage?.discountedValue : defaultPackage?.originalValue}+GST per month after trial ends. cancel anytime</div>
            <div className={styles.ftwDisc}>Magicbricks can't access, track, or share your lead data.</div>
            <div className={styles.ftwOffer}>
                <div className={styles.ftwOfferAmt}><span className={styles.rupees}>&#8377;</span>0</div>
                <div className={styles.ftwOfferText}>Platform Fee!</div>
            </div>
            {/* {
              openGstModal &&
              <CenteredPopUp
                setModal={setOpenGstModal}
                children={
                  <GSTModal
                    setGst={setGst}
                    PayModal={() => onClickHandler(originalPrice, offerPrice, packageId, val, balance, recr)} />
                }
                modiferClass={styles.gstPopup}
                closeIcon={true}
              />
            }
            {
              openTryAutoPayModal &&
              <CenteredPopUp
                setModal={setOpenTryAutoPayModal}
                children={
                  <AutomaticBillPayementContent
                    setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
                    PayModal={setOpenGstModal}
                    setRecr={setRecr}
                    originalPrice={originalPrice}
                    offerPrice={offerPrice}
                    packageId={packageId}
                    setOpenTryAutoPayModal={setOpenTryAutoPayModal}
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={true}
              />
            }
            {
              openSetUpAutoPayModal &&
              <CenteredPopUp
                setModal={setOpenSetUpAutoPayModal}
                children={
                  <AutomaticBillSetUpContent
                    setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
                    setOpenRechargeProcessing={setOpenGstModal}
                    originalPrice={originalPrice}
                    offerPrice={offerPrice}
                    packageId={packageId}
                    balance={balance}
                    val={val}
                    discountVal={discountVal}
                    organizationData={organizationData}
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={true}
              />
            } */}
        </div>
    )
}


const mapStateToProps = (state: any) => {
    return {
      user: state.user.data,
      organizationData: state.organization.organizationData,
    };
  };


export default connect(mapStateToProps)(FreeTrialWhatsappModal)